var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "schoolView" }, [
    _c(
      "div",
      { staticClass: "addEditForm" },
      [
        _c("div", { staticClass: "formTitle" }, [_vm._v("新增学校信息")]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "rulesForm",
            staticClass: "demo-form-inline",
            attrs: {
              model: _vm.formInline,
              rules: _vm.rules,
              "label-width": "120px",
            },
          },
          [
            _c(
              "el-row",
              { staticClass: "marRight20" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学校名称", prop: "schoolName" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入名称" },
                          model: {
                            value: _vm.formInline.schoolName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "schoolName", $$v)
                            },
                            expression: "formInline.schoolName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "学校编码", prop: "schoolCode" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入编码" },
                          model: {
                            value: _vm.formInline.schoolCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "schoolCode", $$v)
                            },
                            expression: "formInline.schoolCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "院校类型", prop: "schoolType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择院校类型",
                              disabled: _vm.isDisabled,
                            },
                            on: { change: _vm.isShow },
                            model: {
                              value: _vm.formInline.schoolType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formInline, "schoolType", $$v)
                              },
                              expression: "formInline.schoolType",
                            },
                          },
                          [
                            _vm._l(_vm.optList, function (i) {
                              return [
                                _c("el-option", {
                                  key: i.value,
                                  attrs: { label: i.label, value: i.value },
                                }),
                              ]
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.show != "2"
                  ? _c(
                      "el-col",
                      { staticClass: "a1", attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "所属教育局", prop: "bureauId" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择所属教育局",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formInline.bureauId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formInline, "bureauId", $$v)
                                  },
                                  expression: "formInline.bureauId",
                                },
                              },
                              [
                                _vm._l(_vm.eduList, function (i) {
                                  return [
                                    _c("el-option", {
                                      key: i.id,
                                      attrs: { label: i.name, value: i.id },
                                    }),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.onSubmit("rulesForm")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.isBack } },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }